import React from "react";

function Maintanance() {
  return (
    <div style={{}}>
      <div
        style={{
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "90vh",
        }}
      >
        {/* <img src={Logo} height="300" alt="logo" /> */}
        <div style={{ fontSize: 22, fontWeight: "bold" }}>
          WE ARE COMING SOON
        </div>
        <div style={{ fontSize: "4rem", fontWeight: "bold", marginBottom: 15 }}>
          Website under maintenance!
        </div>
        <div style={{ fontSize: 18, fontWeight: 400 }}>
          This website is currently undergoing scheduled maintenance. We should
        </div>
        <div style={{ fontSize: 18, fontWeight: 400 }}>be back shortly</div>
      </div>
    </div>
  );
}

export default Maintanance;
